class Nav {
  constructor() {
    this.burger = document.querySelector('.js-burger')
    this.menu   = document.querySelector('.js-mobile-menu')

    if (!this.burger || !this.menu) return

    this.burger.addEventListener('click', () => this.toggle())
  }

  toggle() {
    const isOpen = this.menu.classList.contains('is-open')
    isOpen ? this.close() : this.open()
  }

  open() {
    this.burger.classList.add('is-active')
    this.burger.setAttribute('aria-expanded', 'true')
    this.menu.classList.add('is-open')
    this.menu.setAttribute('aria-hidden', 'false')
    document.body.style.overflow = 'hidden'
    document.documentElement.style.overflow = 'hidden'
  }

  close() {
    this.burger.classList.remove('is-active')
    this.burger.setAttribute('aria-expanded', 'false')
    this.menu.classList.remove('is-open')
    this.menu.setAttribute('aria-hidden', 'true')
    document.body.style.overflow = ''
    document.documentElement.style.overflow = ''
  }
}

export { Nav }
